export default "__VITE_ASSET__CaqeGg4o__"